import { render, staticRenderFns } from "./ErrorNotification.vue?vue&type=template&id=939693ca&scoped=true"
import script from "./ErrorNotification.vue?vue&type=script&lang=js"
export * from "./ErrorNotification.vue?vue&type=script&lang=js"
import style0 from "./ErrorNotification.vue?vue&type=style&index=0&id=939693ca&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939693ca",
  null
  
)

export default component.exports